import codes from './codes';
import ErrorComponent from './ErrorComponent';
import pageNotFoundError from './pageNotFoundError';

function augmentError(error, data) {
  error.data = {
    ...error.data,
    ...data,
  };
}

function formatForLog(error) {
  return {
    error: {
      code: error.code,
      stack: error.stack?.replace(/\s+/g, ' '),
      message: error.message,
      data: error.data,
    },
  };
}

export { augmentError, codes, ErrorComponent, formatForLog, pageNotFoundError };
